import React, { useState } from 'react';
import './RegistrationPage.css';
import { useNavigate } from 'react-router-dom';
import { countries, laosProvinces } from '../utils/countries';
import logo from './logo.png';

const isLaos = (val = "") => {
  const v = String(val).toLowerCase().trim();
  return v === "laos";
};

function RegistrationPage() {
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
    first_name: '',
    middle_name: '',
    last_name: '',
    email: '',
    telephone_number: '',
    date_of_birth: '',
    gender: '',
    address: '',
    address_line2: '',
    city: '',
    state_province: '',
    zip_code: '',
    country: "Laos",
    nationality: "Laos",
    role_id: '',
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const navigate = useNavigate();

const handleSubmit = async (e) => {
  e.preventDefault();
  setError(null);
  setSuccess(null);

  if (formData.password !== formData.confirmPassword) {
    setError('Passwords do not match');
    return;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/users/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...formData,
        role_id: parseInt(formData.role_id, 10),
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Registration failed. Please try again.');
    }

    navigate('/registration-success');
  } catch (error) {
    setError(error.message);
  }
};

  return (
<div className="registration-layout">
<div className="registration-info">
<img src={logo} alt="ERC Logo" className="erc-logo" />

  <h2>Welcome to the National Ethics Committee for Health Research (NECHR) Lao PDR Submission Portal</h2>
  <p>Register here to submit your proposals for ethical review. Once registered, you can manage documents, track your submissions, and receive feedback from NECHR staff.</p>
{



}
</div>


  <div className="registration-container">
      <form className="registration-form" onSubmit={handleSubmit}>
        <h1>Register into your account</h1>
   <div className="form-section">
          <div className="form-field">
            <label>
              First Name <span className="required">*</span>
            </label>
            <input
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-field">
            <label>Middle Name</label>
            <input
              type="text"
              name="middle_name"
              value={formData.middle_name}
              onChange={handleChange}
            />
          </div>
          <div className="form-field">
            <label>
              Last Name <span className="required">*</span>
            </label>
            <input
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-field">
            <label>
              Date of Birth <span className="required">*</span>
            </label>
            <input
              type="date"
              name="date_of_birth"
              value={formData.date_of_birth}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-field">
            <label>
              Gender <span className="required">*</span>
            </label>
            <select name="gender" value={formData.gender} onChange={handleChange} required>
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

<div className="form-field">
  <label>Nationality <span className="required">*</span></label>
  <select
    name="nationality"
    value={formData.nationality}
    onChange={handleChange}
    required
  >
    <option value="">Select Nationality</option>
    {countries.map((country) => (
      <option key={country} value={country}>{country}</option>
    ))}
  </select>
</div>
        </div>
        <div className="form-section">
          <div className="form-field">
            <label>
              Email <span className="required">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-field">
            <label>
              Phone <span className="required">*</span>
            </label>
            <input
              type="tel"
              name="telephone_number"
              value={formData.telephone_number}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-section">
          <div className="form-field">
            <label>
              Password <span className="required">*</span>
            </label>
            <div className="password-field">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <span onClick={togglePasswordVisibility} className="eye-icon">
                &#128065;
              </span>
            </div>
          </div>
          <div className="form-field">
            <label>
              Confirm Password <span className="required">*</span>
            </label>
            <input
              type={showPassword ? 'text' : 'password'}
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-section">
          <div className="form-field">
            <label>
              Street Address <span className="required">*</span>
            </label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-field">
            <label>Address Line 2</label>
            <input
              type="text"
              name="address_line2"
              value={formData.address_line2}
              onChange={handleChange}
            />
          </div>
          <div className="form-field">
            <label>
              City <span className="required">*</span>
            </label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-field">
            <label>State/Province <span className="required">*</span></label>

            {isLaos(formData.country) ? (
              <select
                name="state_province"
                value={formData.state_province || ""}
                onChange={handleChange}
                required
              >
                <option value="">Select Province</option>
                {laosProvinces.map((p) => (
                  <option key={p} value={p}>{p}</option>
                ))}
              </select>
            ) : (
              <input
                type="text"
                name="state_province"
                value={formData.state_province || ""}
                onChange={handleChange}
                required
                placeholder="Enter state/province"
              />
            )}
          </div>
          <div className="form-field">
            <label>
              ZIP Code
            </label>
            <input
              type="text"
              name="zip_code"
              value={formData.zip_code}
              onChange={handleChange}
            />
          </div>
          <div className="form-field">
            <label>Country <span className="required">*</span></label>
            <select name="country" value={formData.country} onChange={handleChange} required>
              <option value="">Select Country</option>
              {countries.map((country) => (
                <option key={country}  value={country}>{country}</option>
              ))}
            </select>
          </div>
        </div>
        <button type="submit">Register</button>

        {error && <p className="error-message">{error}</p>}
        {success && <p className="success-message">{success}</p>}
      </form>
      </div>
      </div>
  );
}

export default RegistrationPage;
